'use strict';

/* globals Modernizr */

const _ = require('lodash');

const ForgotPasswordFormController = function ($scope, sbAuth, IntercomService, RoutingUtil) {

  const vm = this;
  vm.buttonText = 'Submit';
  vm.currentView = '';
  vm.error = '';
  vm.inputs = ['email'];
  vm.isTouch = typeof Modernizr !== 'undefined' && Modernizr.touch;
  vm.menuActive = false;
  vm.text = 'There is no account associated with this email address. Please make sure you’ve entered it correctly.';
  vm.data = {
    email: '',
    origin: 'core'
  };

  vm.loadingSendEmail = false;

  vm.sendEmail = _.debounce(() => {

    vm.buttonText = 'Loading...';

    vm.loadingSendEmail = true;
    const onError = (res) => {

      vm.loadingSendEmail = false;
      vm.buttonText = 'Submit';
      vm.error = res.data.error;
    };

    const onSuccess = () => {

      vm.currentView = 'confirmation';
    };

    sbAuth.generatePasswordResetToken(vm.data, onSuccess, onError);
  }, 50);

  vm.goToLogin = () => {

    RoutingUtil.redirectToLogin();
  };

  vm.openChat = () => {

    IntercomService.show();
  };

  vm.toggleMenu = () => {

    vm.menuActive = !vm.menuActive;
  };
};

module.exports = ForgotPasswordFormController;



// WEBPACK FOOTER //
// ./src/app/login/forgotPasswordForm/ForgotPasswordFormController.js